import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Newsletter() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = () => {
    // Small delay to allow the form to actually send to the iframe before hiding UI
    setTimeout(() => {
      setIsSubmitted(true);
    }, 250);
  };

  return (
    <section id="newsletter" className="bg-etera-ivory py-24 px-6">
      <div className="max-w-xl mx-auto text-center">
        {/* Hidden Iframe for Form Submission */}
        <iframe 
          name="hidden_iframe" 
          id="hidden_iframe" 
          style={{ display: 'none' }}
        ></iframe>

        <AnimatePresence mode="wait">
          {!isSubmitted ? (
            <motion.div
              key="form-container"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-4xl md:text-5xl font-serif text-etera-black mb-4 tracking-tight">
                Únete a la casa del dragón.
              </h2>
              <p className="text-lg text-etera-charcoal mb-10 font-sans leading-relaxed">
                Déjanos tu email para recibir acceso anticipado y lanzamientos exclusivos.
              </p>

              <form
                action="https://sendfox.com/form/1998yn/1vwxpz"
                method="POST"
                target="hidden_iframe"
                onSubmit={handleSubmit}
                className="text-left"
              >
                {/* Honeypot for Spam Protection */}
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                  <input type="text" name="a_password" tabIndex="-1" defaultValue="" />
                </div>

                <div className="space-y-4 mb-6">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="Nombre"
                    required
                    className="bg-transparent border-b-2 border-etera-charcoal focus:border-etera-gold focus:outline-none py-3 w-full transition-colors duration-300 placeholder:text-etera-charcoal/50 text-etera-black font-sans"
                  />
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Apellidos"
                    required
                    className="bg-transparent border-b-2 border-etera-charcoal focus:border-etera-gold focus:outline-none py-3 w-full transition-colors duration-300 placeholder:text-etera-charcoal/50 text-etera-black font-sans"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                    className="bg-transparent border-b-2 border-etera-charcoal focus:border-etera-gold focus:outline-none py-3 w-full transition-colors duration-300 placeholder:text-etera-charcoal/50 text-etera-black font-sans"
                  />
                </div>

                <div className="flex items-center gap-3 mb-8">
                  <input type="checkbox" name="gdpr" value="1" id="consent" required className="w-4 h-4 accent-etera-gold cursor-pointer" />
                  <label htmlFor="consent" className="text-sm text-etera-charcoal cursor-pointer font-sans">
                    Acepto recibir comunicaciones.
                  </label>
                </div>

                <button
                  type="submit"
                  className="w-full bg-etera-gold text-etera-black font-bold py-4 uppercase tracking-[0.2em] text-sm transition-all duration-300 hover:bg-etera-charcoal hover:text-etera-ivory"
                >
                  Unirme
                </button>
              </form>
            </motion.div>
          ) : (
            <motion.div
              key="success-message"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-etera-black text-etera-gold py-16 px-8 rounded-sm shadow-2xl border border-etera-gold/20"
            >
              <h3 className="text-2xl md:text-3xl font-serif mb-4">Bienvenido.</h3>
              <p className="text-etera-ivory/80 font-sans tracking-wide">
                Revisa tu bandeja de entrada.
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}